export enum CompanyRolesEnum {
    DASHBOARD = 'dashboard',
    API = 'api',
}